import React from 'react'
import AppPageComponent from '@components/page/appPage.component'
import PageHeaderComponent from '@components/page/pageHeader.component'
import PageBodyComponent from '@components/page/pageBody.component'
import { Route, Routes } from 'react-router-dom'
import PlaylistComponent from '@components/playlist/playlist.component'
import PlaylistOutlineComponent from '@components/playlist/playlistOutline.component'
import SlotComponent from '@components/slot/slot.component'
import PlaylistPublishedComponent from '@components/playlist/playlistPublished.component'
import PlaylistAudioListComponent from '@components/playlist/playlistAudioList.component'
import 'react-datepicker/dist/react-datepicker.css'
import PlaylistDetailComponent from '@components/playlist/playlistDetail.component'
import Breadcrumbs from '@components/shared/breadcrumbs.component'
import NotFoundPage from '@pages/notFound.page'
import ActionButtons from '@components/shared/actionButtons.component'

const PlaylistPage: React.FC = () => {
  return (
    <AppPageComponent>
      <PageHeaderComponent>
        <div>
          <Breadcrumbs></Breadcrumbs>
        </div>
        <div>
          <PlaylistDetailComponent />
        </div>
        <div className="my-2">
          <ActionButtons></ActionButtons>
        </div>
      </PageHeaderComponent>
      <PageBodyComponent>
        <Routes>
          <Route
            path=""
            element={
              <div className="w-50 my-2">
                <PlaylistComponent />
              </div>
            }
          />
          <Route path="/outline/*" element={<PlaylistOutlineComponent />} />
          <Route path="/slot/:slotId/*" element={<SlotComponent />} />
          <Route path="/audio" element={<PlaylistAudioListComponent />} />
          <Route path="/published" element={<PlaylistPublishedComponent />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </PageBodyComponent>
    </AppPageComponent>
  )
}

export default PlaylistPage
